<a
  data-cy="main-nav-signin"
  [attr.title]="'header.login' | transloco"
  (click)="onLoginButtonClick()">
  {{ 'header.login' | transloco }}
</a>
